import { getStopApi } from '../../../services/StopApi/StopApi';
export const { REACT_APP_STOP_BASE_URL } = process.env;

export const getContactList = async ({ commonParams, authorization }) => {
  return await getStopApi({
    commonParams,
    authorization,
  }).then((response) => {
    const json = response.data;
    return {
      isLoading: false,
      total: response?.totalRows,
      data: json?.map((item, index) => ({
        ...item,
        id: index,
        contactKey: item.contactKey,
        cntId: item.cntId,
        directWorkPhone: item.directWorkPhone,
        eMail: item.eMail,
        orgKey: item.orgKey,
        parole: item.parole,
        inactive: item.inactive,
      })),
    };
  }).catch((e) => alert(e));
};


export const getContactByUser = async (user) => {
  let username = user.username;
  if (username?.includes('_')) username = username.split('_')[1];
  if (username?.includes('@')) username = username.split('@')[0];
  const commonParams = `${REACT_APP_STOP_BASE_URL}api/Contact/detailsByName/${username}`;
  const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;  

  return await getStopApi({
    commonParams,
    authorization,
  }).then((response) => {
    return response.data;
  }).catch((e) => alert(e));
};